const HighlightLinks = () => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.101562"
        width="92.696"
        height="92.696"
        rx="46.348"
        transform="rotate(0.0638669 0.101562 0)"
      />
      <path
        d="M50.1958 45.4957C50.1863 54.0004 43.3054 60.866 34.8007 60.8566C26.296 60.8471 19.4304 53.9661 19.4399 45.4615C19.4494 36.9568 26.3303 30.0912 34.835 30.1006"
        stroke="black"
        strokeWidth="6.01747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.8298 45.4851C40.8396 36.6327 48.0419 29.4465 56.8942 29.4564C65.7466 29.4662 72.9328 36.6685 72.9229 45.5208C72.9131 54.3732 65.7108 61.5594 56.8585 61.5495"
        stroke="black"
        strokeWidth="6.01747"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.4211 20.43L64.0444 16.6246C65.0454 15.5734 65.0047 13.9112 63.9534 12.9103C62.9029 11.91 61.24 11.9501 60.2391 13.0013L56.6158 16.8066C55.6148 17.8579 55.6562 19.5207 56.7068 20.521C57.758 21.5219 59.4202 21.4812 60.4211 20.43Z"
        fill="black"
      />
      <path
        d="M28.0528 17.3416L31.8581 20.965C32.9093 21.9659 34.5715 21.9252 35.5725 20.874C36.5728 19.8234 36.5327 18.1605 35.4815 17.1596L31.6761 13.5363C30.6249 12.5353 28.9621 12.5767 27.9618 13.6273C26.9608 14.6785 27.0016 16.3407 28.0528 17.3416V17.3416Z"
        fill="black"
      />
      <path
        d="M48.7609 13.2055L48.6699 9.49113C48.5302 8.12561 47.3636 7.09706 45.9915 7.13063C44.6194 7.1642 43.5046 8.24879 43.4319 9.61946L43.5229 13.3338C43.6627 14.6993 44.8292 15.7266 46.2013 15.693C47.5733 15.6594 48.6882 14.5761 48.7609 13.2055L48.7609 13.2055Z"
        fill="black"
      />
      <path
        d="M60.3716 71.9209L63.9865 75.7343C64.9851 76.7878 64.9406 78.4499 63.8872 79.4484C62.8344 80.4464 61.1716 80.4026 60.173 79.3492L56.5582 75.5357C55.5596 74.4823 55.6047 72.8196 56.6575 71.8216C57.7109 70.823 59.373 70.8675 60.3716 71.9209Z"
        fill="black"
      />
      <path
        d="M27.995 74.9382L31.8084 71.3234C32.8619 70.3248 34.5239 70.3692 35.5225 71.4227C36.5205 72.4755 36.4767 74.1382 35.4232 75.1368L31.6098 78.7517C30.5564 79.7503 28.8936 79.7051 27.8957 78.6524C26.8971 77.5989 26.9416 75.9368 27.995 74.9382V74.9382Z"
        fill="black"
      />
      <path
        d="M48.6987 79.1186L48.5995 82.8328C48.4567 84.198 47.2878 85.2239 45.9158 85.1873C44.5438 85.1507 43.4314 84.0636 43.3618 82.6928L43.461 78.9786C43.6038 77.6134 44.7727 76.5888 46.1446 76.6254C47.5166 76.6621 48.6291 77.7478 48.6987 79.1186L48.6987 79.1186Z"
        fill="black"
      />
    </svg>
  );
};

export default HighlightLinks;
